import * as React from "react";
import ErrorIcon from "@mui/icons-material/Error";

import { Link } from "@mui/material";

function KioskRowErrorLink({ syncErrorRef, locationCode }) {
  if (syncErrorRef === undefined || syncErrorRef === null) {
    return <></>;
  }

  const params = new URLSearchParams({
    inboundCode: locationCode
  });

  return (
    <Link
      href={`/dashboard/ErrorLogs/${syncErrorRef}?${params.toString()}`}
      color="inherit"
      style={{ height: "24px" }}
    >
      <ErrorIcon color="error" />
    </Link>
  );
}

export default KioskRowErrorLink;
